"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getContentIdsOfContent_1 = require("../../helpers/getContentIdsOfContent");
function filterToForceCompleteContentByContent(command, content) {
    try {
        const contentIdsOfContent = getContentIdsOfContent_1.getContentIdsOfContent(content);
        return contentIdsOfContent.filter(contentId => command.contentIds.indexOf(contentId) > -1);
    }
    catch (error) {
        throw new Error('Error in filterToForceCompleteContentByContent ' + error);
    }
}
exports.filterToForceCompleteContentByContent = filterToForceCompleteContentByContent;
//# sourceMappingURL=filter.js.map